<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-close"
  >
    <path
      d="M5.25628157,5.25628157 C5.59799032,4.91457281 6.15200968,4.91457281 6.49371843,5.25628157 L12,10.761875 L17.5062816,5.25628157 C17.821705,4.9408581 18.3180322,4.91659476 18.661287,5.18349154 L18.7437184,5.25628157 C19.0854272,5.59799032 19.0854272,6.15200968 18.7437184,6.49371843 L13.23725,12 L18.7437184,17.5062816 C19.0591419,17.821705 19.0834052,18.3180322 18.8165085,18.661287 L18.7437184,18.7437184 C18.4020097,19.0854272 17.8479903,19.0854272 17.5062816,18.7437184 L12,13.23725 L6.49371843,18.7437184 C6.17829497,19.0591419 5.68196779,19.0834052 5.33871299,18.8165085 L5.25628157,18.7437184 C4.91457281,18.4020097 4.91457281,17.8479903 5.25628157,17.5062816 L10.761875,12 L5.25628157,6.49371843 C4.9408581,6.17829497 4.91659476,5.68196779 5.18349154,5.33871299 L5.25628157,5.25628157 Z"
    />
  </svg>
</template>
